import {
  PostPrivacyOptionsVariant,
  PrivacyOptionsVariant,
} from '../../../types'

export const POST_TO_REPLY_PRIVACY_VARIANT: Record<
  PostPrivacyOptionsVariant,
  PrivacyOptionsVariant
> = {
  [PrivacyOptionsVariant.GroupChannelPublicPost]:
    PrivacyOptionsVariant.GroupChannelPublicReply,
  [PrivacyOptionsVariant.GroupChannelPrivatePost]:
    PrivacyOptionsVariant.GroupChannelPrivateReply,
  [PrivacyOptionsVariant.Post]: PrivacyOptionsVariant.Reply,
}

const isPostPrivacyVariant = (
  value: PrivacyOptionsVariant | undefined,
): value is PostPrivacyOptionsVariant =>
  value != null && value in POST_TO_REPLY_PRIVACY_VARIANT

export default isPostPrivacyVariant
